// extracted by mini-css-extract-plugin
export default {"button":"PostButton_button__JvRiB","disable":"PostButton_disable__NBd2h"};